import { registerActivity } from '../utils/appConfig'

/**
 * Server-side activity registration for SSR and API routes.
 * Called from pageFactory on every SSR request to feed
 * the idle-detection logic in AppConfigService.
 */
export function registerServerActivity(): void {
  try {
    registerActivity()
  } catch (error) {
    console.debug('Failed to register server activity:', error)
  }
}
